import {
  IsNotEmpty,
  IsArray,
  ArrayMinSize,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { DogShowClassesDto } from "./dog-show-classes.dto";

export class EventDogShowsDto {
  @IsNotEmpty()
  show_id: string;

  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => DogShowClassesDto)
  dogs: DogShowClassesDto[];
}
